import { EnumBase } from 'hay-core-react';
class MidiaTipoEnum extends EnumBase {
    constructor() {
        super(['main.midia.tipo.imagem', 'main.midia.tipo.video'], 'main.midia.tipo.imagem');
    }
}

const instance = new MidiaTipoEnum();
export default instance;
